import { Button, Col, Container, Row } from "react-bootstrap";

const Categories = ({ defaultCategories, handleUpdateTag }) => {
  return (
    <section className="categories mt-3">
      <Container className="mini-container">
        <Row>
          {defaultCategories.map(({ id, title }) => (
            <Col key={id} xs={6} md={3} className="mb-2 mb-sm-0">
              <Button variant="dark" className="w-100" onClick={() => handleUpdateTag(title)}>
                {title}
              </Button>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Categories;
